import React, { useState, useEffect, useRef, useCallback } from "react";
import EmailEditor from "react-email-editor";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Table,
  Modal,
  Image,
  Form,
} from "react-bootstrap";
import moment from "moment";
import Alert from "react-s-alert";
import ReactHtmlParser from "react-html-parser";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Loader from "react-loader-spinner";
import InputNumberFunc from "./../../../../function/InputNumberFunc";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import { useFormik } from "formik";
import * as yup from "yup";
import SearchIcon from "@material-ui/icons/Search";
import {
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  Paper,
  InputBase,
  IconButton,
  TextField,
  List,
  ListItem,
  Divider,
} from "@material-ui/core";
import ChoosePreferenceModel from "./ChoosePreferenceModel";
import ChooseUserAttributes from "./ChooseUserAttributes";
import propTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  admin_add_sms_email_template,
  admin_get_user_vendor_info,
} from "../../../../store/actions/SuperAdminActions/adminTemplatesAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import en from "react-phone-number-input/locale/en.json";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert } from "../../../../function/alert";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import SelectMapLocation from "../../../reusableComponents/selectMapLocation/selectMapLocation";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Select as MuiSelect } from "@material-ui/core";
import { rest } from "lodash";
import Debounce from "../../../../function/debounce";
// const validationSchema = yup.object({
//   account_type: yup.string().required("Please select account type"),
// });

const modes = ["KMS", "Meters", "Miles"];

export const SuperAdminAddSmsTemplate = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();

  /***************************************
   * @DESC Change Route using location
   ***************************************/
  const [urlPath, setUrlPath] = useState("");
  useEffect(() => {
    setUrlPath(location.state.actionPerform);
  //   const token = props.auth.user.accessToken;
  //   dispatch(admin_get_user_vendor_info(token, "USER"));
  }, [location]);

  /**********************************************
   * @DESC Get User and Vendor Information
   **********************************************/
  const [addData, setVal] = useState("");
  const [addedData, showData] = useState(0);
  const [wholeData, setWholedata] = useState({});
  const [checkpreferences,setcheck]=useState(true)
  const [showUserAdd, setuserAdd] = useState(false);
  const [displayDropDown, setdisplayDropDown] = useState(true);
  const onNextHoursOpen = () => setdisplayDropDown(!displayDropDown);
  const [displayDropDownlocations, setdisplayDropDownlocations] = useState(true);
  const onOpenAddedlocations = () => setdisplayDropDownlocations(!displayDropDownlocations);

  //setting array id's //
  let [genderids, setgenderids] = useState([]);
  let [allergiesids, setAllergies] = useState([]);
  let [cusinesids, setcusinesids] = useState([]);
  let [dietaryids, setdietary] = useState([]);

  useEffect(() => {
    assignvalues();
    //  filterder_attributes();
  }, [wholeData]);

  const assignvalues = () => {
    if (wholeData?.gender) {
      wholeData.gender.map((data, index) => {
        genderids.push(data.value);
      });
    }
    if (wholeData?.Allergies?.length) {
      wholeData.Allergies.map((data, index) => {
        allergiesids.push(data.value);
      });
    }
    if (wholeData?.Cuisines?.length) {
      wholeData.Cuisines.map((data, index) => {
        cusinesids.push(data.value);
      });
    }
    if (wholeData?.Dietary?.length) {
      wholeData.Dietary.map((data, index) => {
        dietaryids.push(data.value);
      });
    }
  };

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userData, setUserData] = useState({
    mobile_number: "",
    email: "",
    data: null,
  });

  const [locationPointers, setLocationPointers] = useState({
    markers: [],
    list: [],
  });

  const [rest, setRest] = useState({ restaurant_name: "" });

  const [rests, setRests] = useState([]);

  const [locData, setLocData] = useState({
    lat: "",
    lng: "",
    radius: "",
    radiusType: "KMS",
  });

  const [addLocations, setAddLocations] = useState([]);

  const formik = useFormik({
    initialValues: {
      user_type: false,
    },
  });

  // useEffect(() => {
  //   const token = props.auth.user.accessToken;
  //   dispatch(
  //     admin_get_user_vendor_info(
  //       token,
  //       formik.values.user_type ? "VENDOR" : "USER"
  //     )
  //   );
  // }, [formik.values.user_type]);

  /**********************************************
   * @DESC Set User and Vendor Information
   **********************************************/
  const [state, setState] = useState({
    search: "",
    code: props.auth.user.VendorUser.country_code,
    Language: "English",
    email: "",
  });
  const [state1, setstate1] = useState({
    email: "",
    mobile: ""
  });
  const [getVendorUserInfo, setVendorUserInfo] = useState([]);
  const emailEditorRef = useRef(null);
  useEffect(() => {
    setVendorUserInfo(
      formik.values.user_type
        ? props.getVendorUserDetails
        : props.getVendorUserDetails.users
    );
  }, [props.getVendorUserDetails]);

  var filteredData = getVendorUserInfo && getVendorUserInfo;

  if (state.search) {
    let searchData = new RegExp(state.search, "i");
    filteredData =
      getVendorUserInfo &&
      getVendorUserInfo.filter((getall) => {
        if (searchData.test(getall._id)) {
          return getall;
        } else if (searchData.test(getall.email)) {
          return getall;
        } else if (searchData.test(getall.mobile_number)) {
          return getall;
        } else if (searchData.test(getall?.restaurant_id?.restaurant_name)) {
          return getall;
        } else if (
          searchData.test(getall?.first_name + " " + getall?.last_name)
        ) {
          return getall;
        } else {
          return false;
        }
      });
  }

  /***************************
   * @DESC Add Form Data
   **************************/
  const [newHtmlDesignCode, setHtmlDesignCode] = useState({});
  const [design, setDesign] = useState({});
  const formik1 = useFormik({
    initialValues: {
      headCheck: false,
      perticularYearMonth: "",

      title: "",
      message: "",
      desgin: {},
      htmlCode: {},
      role: 0,
      startDate: "",
      endDate: "",
      status: false,
      isHold: false,
      isSendLater: false,
      sendNowCompleted: false,
      isApprove: false,
      reason: "",
      comment: "",
      frequency: 1,
      startTriggeredAt: "",
      endTriggeredAt: "",
      repeatEvery: "",
      days: [],
      isOnPerticularDay: false,
      onPerticularDay: "",
      week_frequency: "",
      month: "",
      vendorArr: [],
      userArr: [],
      preferences: {
        dobFrom: "",
        dobTo: "",
        anniversaryFrom: "",
        anniversaryTo: "",
        activeUsersFrom: "",
        activeUsersTo: "",
        country: [],
        state: [],
        city: [],
        gender: [],
        cuisines: [],
        allergies: [],
        dietary: [],
      },
    },
    validationSchema: yup.object({
      title: yup
        .string()
        .required("title is required")
        .min(1, "Minimum 1 Character")
        .max(64, "Maximum 64 Character"),
      // message: yup
      //   .string()
      //   .required(
      //     `${
      //       urlPath === "SMS"
      //         ? "SMS"
      //         : urlPath === "EMAIL"
      //         ? "Email"
      //         : urlPath === "NOTIFICATION"
      //         ? "Notification"
      //         : ""
      //     } content is required`
      //   )
      //   .min(50, "Minimum 50 Character")
      //   .max(512, "Maximum 512 Character"),
    }),

    onSubmit: (values) => {
      let year = "2021-";
      let singleDate = values.onPerticularDay;
      let monthDate =
        values.perticularYearMonth === "" ? "01" : values.perticularYearMonth;
      let onPerticularDayDate =
        year + monthDate + "-" + singleDate + "T" + "09:30";

      const start_Date = moment(
        values.startDate + "T" + values.startTriggeredAt
      ).valueOf();
      const end_Date = moment(
        values.endDate + "T" + values.endTriggeredAt
      ).valueOf();

      var formData = {};
      formData.title = values.title;
      formData.message = values.message;
      formData.design = design;
      formData.htmlCode = newHtmlDesignCode;
      formData.role = formik.values.user_type ? 1 : 0;
      formData.status = false;
      formData.isHold = false;
      formData.isSendLater = values.isSendLater;
      formData.sendNowCompleted = false;
      formData.isApprove = false;
      if (values.isSendLater) {
        formData.startDate = moment(values.startDate).valueOf();
        formData.endDate = moment(values.endDate).valueOf();
        formData.startTriggeredAt = start_Date;
        formData.frequency = values.frequency;
        formData.week_frequency = values.week_frequency;
        formData.isOnPerticularDay = values.isOnPerticularDay;
        formData.repeatEvery = values.repeatEvery;
        formData.days = values.days;
        formData.month = values.month;
      }
      if (values.frequency === 0) {
        formData.endTriggeredAt = end_Date;
      }
      if (values.frequency === 3 || values.frequency === 4) {
        formData.onPerticularDay = moment(onPerticularDayDate).valueOf();
      }
      formData.reason = values.reason;
      formData.comment = values.comment;
      formData.user_id = values.userArr;
      formData.vendor_id = values.vendorArr;
      formData.preferences = {
        dobFrom: wholeData?.DobStarDate,
        dobTo: wholeData?.DobSEndDate,
        anniversaryFrom: wholeData?.AnniversaryStarDate,
        anniversaryTo: wholeData?.AnniversaryEndDate,
        activeUsersFrom: wholeData?.ActiveUsersStartdate,
        activeUsersTo: wholeData?.ActiveUsersenddate,
        country: [wholeData?.country],
        state: [wholeData?.state],
        city: [wholeData?.city],
        gender: genderids,
        cuisines: cusinesids,
        allergies: allergiesids,
        dietary: dietaryids,
      }; // You need to send me the object
      formData.locations = addLocations;
      formData.selectedUsers = selectedUsers;
      formData.sendToAll = wholeData?.sendToAll === 0 ? true : false; // Need to change by variable

      const token = props.auth.user.accessToken;
      props.admin_add_sms_email_template(
        formData,
        token,
        urlPath,
        onSuccess(urlPath)
      );
    },
  });

  const onSuccess = (url) => {
    if (url === "SMS") {
      history.push("/superadminsmstemplatemanagement");
    } else if (url === "EMAIL") {
      history.push("/superadminemailtemplatemanagement");
    } else {
      history.push("/superadmin-notification-templatemanagement");
    }
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik1.handleSubmit();
  };

  useEffect(() => {
    if (formik1.errors && formik1.errors.title) {
      let titleElement = document.getElementById("title");
      titleElement.focus();
    }
    // else if (formik1.errors && formik1.errors.message) {
    //   let messageElement = document.getElementById("message");
    //   messageElement.focus();
    // }
  }, [count]);

  // console.log(wholeData,"wholeeeee");
  const exportHtml = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { design, html } = data;
      formik1.setFieldValue("message", html);
      setDesign(design);
    });
  };

  const onDesignLoad = (data) => {
    console.log("onDesignLoad", data);
  };

  const onLoad = () => {
    if (emailEditorRef.current !== null) {
      emailEditorRef.current.editor.addEventListener(
        "onDesignLoad",
        onDesignLoad
      );
    }
    // emailEditorRef.current.editor.loadDesign(templateData);
  };

  const [actionsButton, setActionButton] = useState(false);
  const [openExportModal, setExportModal] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const handleChangeCode = (event) => {
    const code = event.target.name;
    setState({
      ...state,
      [code]: event.target.value,
    });
  };

  const onUserSearch = async (event) => {
    try {
      let query = {};
      let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      if (event.length === 10 && !isNaN(Number(event))) {
        query.mobile_number = event;
        query.country_code = state.code;
      } else if (emailRegex.test(event)) {
        query.email = event;
      }

      if (!isEmpty(query)) {
        let userData = await amApi.get(`/user-check`, { params: query });
        //     console.log('userData', userData)
        if (userData.status === 200 && !isEmpty(userData.data)) {
          setuserAdd(true);
          setUserData({
            mobile_number: userData?.data?.mobile_number,
            email: userData?.data?.email,
            data: userData?.data,
          });
          if (!state1.email) {
            setstate1({
              ...state1,
              email: userData?.data?.email,
            });
          }
        } else {
          setuserAdd(false);
        }
      }
    } catch (err) {
      errorAlert("User Not Found");
      setuserAdd(false);
      setUserData({
        ...userData,
        data: null,
      });
    }
  };

  const onSelectUsers = (data) => {
    if (!isEmpty(data)) {
      let d = [
        ...selectedUsers,
        {
          _id: data?._id,
          first_name: data?.first_name,
          last_name: data?.last_name,
          mobile_number: data?.mobile_number,
          FCMtoken: data?.FCMtoken,
          email: data?.email,
          country_code: data?.country_code,
        },
      ];
      setSelectedUsers(d);

      setstate1({ email: "", mobile: "" });
    }
  };

  const onDeleteUsers = (data) => {
    let d = selectedUsers.filter((e) => e?._id !== data?._id);
    setSelectedUsers(d);
  };

  const onDeleteLocations = (data) => {
    let d = addLocations.filter((e) => e?.lat !== data?.lat);
    setAddLocations(d);
  };

  const onAddLocation = (data) => {
    let d = rest?.restaurant_name
      ? rest.restaurant_name
      : `Lat : ${parseInt(locData.lat).toFixed(4)} - Lng : ${parseInt(
        locData.lng
      ).toFixed(4)}`;
    setLocationPointers({
      markers: [
        ...locationPointers.markers,
        { lat: Number(locData.lat), lng: Number(locData.lng) },
      ],
      list: [...locationPointers.list, d],
    });
      setAddLocations([
        ...addLocations,
        {
          restaurant_name: rest?.restaurant_name || "",
          ...locData,
        },
      ]);
    
    setLocData({
      lat: "",
      lng: "",
      radius: "",
      radiusType: "KMS",
    });
    setRest({
      restaurant_name: "",
    });
  };

  const onLocationSelect = async (loc) => {
    let lat = loc.latLng.lat();
    let lng = loc.latLng.lng();
    setLocData({
      ...locData,
      lat: lat,
      lng: lng,
    });
  };

  const onRestSelect = (data) => {
    setRests([]);
    setRest({
      restaurant_name: data.restaurant_name,
      lat: data.location.coordinates[1],
      lng: data.location.coordinates[0],
    });
    setLocData({
      ...locData,
      lat: data.location.coordinates[1],
      lng: data.location.coordinates[0],
    });
  };


  const onChange = async (value) => {
    try {
      if (value) {
        let data = await amApi.get(`/searchRestaurant?name=${value}`);
        data = data.data;
        setRests(data);
      }
    } catch (err) {
      errorAlert("Something went wrong, try again later");
    }
  };
  console.log(selectedUsers, "array");

  const debounceOnChange = useCallback(Debounce(onChange, 1000), []);
  //  console.log(wholeData,"datasentttttttt");
  // console.log(formik1.values,"values")
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Container fluid>
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue ">
                    Create{" "}
                    {urlPath === "SMS"
                      ? "SMS"
                      : urlPath === "EMAIL"
                      ? "Email"
                      : urlPath === "NOTIFICATION"
                      ? " Push Notification"
                      : ""}{" "}
                    {/* Template Management */}
                  </div>
                </div>
                <div>
                  <div className="f18-700 mt-2">Select User Type*</div>
                  <div className="col-11 p-0 mt-4 mb-3 pl-0">
                    <div className="d-flex align-items-center justify-content-between">
                      <ChooseUserAttributes
                        AttributesData={(e) => setWholedata(e)}
                        datacheck={(e) => setcheck(e)}
                      />

                    </div>
                    <div className="col-11 my-2">
                      <SelectedAttributes wholeData={wholeData} />
                      {/* {filterder_attributes()} */}
                    </div>

                    <div className="col-12 p-0">
                      <hr />
                    </div>
                  </div>
                  <div>
                    <div className="f18-700 my-1">Search Users by</div>
                    <div className="f12-400 opacity5">
                      You can search for all the active users irrespective of
                      selected attributes
                    </div>
                    <div className="col-9 my-4 align-items-center">
                      <Row>
                        <Col xs={2} className="pr-0">
                          <FormControl variant="outlined" className="w-100">
                            <Select
                              value={state.code}
                              onChange={handleChangeCode}
                              inputProps={{
                                name: "code",
                              }}
                            >
                              <option value={state.country_code}>
                                {state.country_code}
                              </option>
                              {getCountries().map((country) => (
                                <option
                                  key={country}
                                  value={"+" + getCountryCallingCode(country)}
                                >
                                  {en[country]} (+
                                  {getCountryCallingCode(country)})
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                        </Col>
                        <Col xs={4}>
                          <Form.Group>
                            <TextField
                              id="mobile_number"
                              //id="outlined-basic"
                              type="number"
                              max="10"
                              label="Phone Number"
                              variant="outlined"
                              className={`w-100`}
                              name="mobile_number"
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onChange={(e) => { setstate1({ ...state1, mobile: e.target.value }); onUserSearch(e.target.value); }}
                              value={state1.mobile}
                            // onBlur={formik1.handleBlur}
                            //onInvalid={formik1.errors.email && formik1.touched.email}
                            // isInvalid={
                            //   formik1.errors.mobile_number &&
                            //   formik1.touched.mobile_number
                            // }
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <NewInputText
                              id="email"
                              type="email"
                              label="Email Address"
                              variant="outlined"
                              className={`w-100`}
                              name="email"
                              onChange={(e) =>
                                setstate1({ email: e.target.value })
                              }
                              // onChange={formik1.handleChange}
                              value={state1.email}
                              onFocusOut={() => {
                                if (
                                  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(
                                    state1.email
                                  )
                                ) {
                                  onUserSearch(state1.email);
                                }
                              }}
                            // onBlur={formik1.handleBlur} 
                            //onInvalid={formik1.errors.email && formik1.touched.email}
                            />
                          </Form.Group>
                        </Col>
                        {showUserAdd && (
                          <>
                            <Col md={2} className="mt-3">
                              <AddButtonIconComponent
                                buttonText="Add"
                                onClick={() => onSelectUsers(userData.data)}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </Col>
                          </>
                        )}
                      </Row>
                    </div>
                    <div className="my-4">
                      <div className="d-flex">
                        <h5
                          className="font_20_m c_red mr-3 cursor"
                          onClick={onNextHoursOpen}
                        >
                          Show Added Users
                        </h5>
                        <div className="cursor">
                          {displayDropDown ? (
                            <i
                              className="fa fa-angle-up c_red"
                              aria-hidden="true"
                              onClick={onNextHoursOpen}
                            ></i>
                          ) : (
                            <i
                              className="fa fa-angle-down c_red"
                              aria-hidden="true"
                              onClick={onNextHoursOpen}
                            ></i>
                          )}
                        </div>
                      </div>

                      {displayDropDown && selectedUsers.length ? (
                        selectedUsers.map((usr) => (
                          <>
                            <Row>
                              <Col xs={5}>
                                <span className="f14-600">
                                  {usr.first_name || ""} {usr.last_name || ""}
                                </span>{" "}
                                <span className="f12-400">
                                  {usr.mobile_number} {usr.email}
                                </span>
                              </Col>
                              <Col xs={3}>
                                <AddButtonIconComponent
                                  buttonText="Delete"
                                  onClick={() => onDeleteUsers(userData.data)}
                                  fontIcon="fa fa-trash"
                                  colorCss="delete"
                                />
                              </Col>
                            </Row>
                          </>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div>
                    <div className="f18-700 my-1">Search Restaurants by</div>
                    <div className="f12-400 opacity5 mb-4">
                      You can search for all the active users irrespective of
                      selected attributes
                    </div>
                  </div>
                  <div className="col-9 my-4 align-items-center">
                    <Row>
                      <Col md={6} className="position-relative">
                        <Form.Group>
                          <TextField
                            id="restaurant"
                            type="text"
                            label="Search by Restaurant"
                            variant="outlined"
                            className={`w-100`}
                            name="search by restaurant"
                            value={rest?.name}
                            onChange={(e) => {
                              setRest({ name: e.target.value });
                              debounceOnChange(e.target.value);
                            }}
                          />
                        </Form.Group>
                        <div className="position-absolute bottom-0 w-100 mh-20">
                          <List
                            dense
                            className="w-100"
                            style={{ zIndex: 999, backgroundColor: "#ffffff" }}
                          >
                            {rests.length ? (
                              rests.map((rest) => (
                                <>
                                  <ListItem
                                    className="p-2 cursor-pointer"
                                    onClick={(e) => onRestSelect(rest)}
                                  >
                                    {rest.restaurant_name}
                                  </ListItem>
                                  <Divider />
                                </>
                              ))
                            ) : (
                              <></>
                            )}
                          </List>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="d-flex">
                    <div className="col-8">
                      <SelectMapLocation
                        location={locationPointers}
                        onSelectLocation={onLocationSelect}
                      />
                    </div>
                    <div className="col-4">
                      <div className="py-4">
                        <TextField
                          id="latitude"
                          type="number"
                          value={locData.lat}
                          label="Latitude"
                          variant="outlined"
                          className={`w-100`}
                          name="latitude"
                          onChange={(e) =>
                            setLocData({ ...locData, lat: e.target.value })
                            
                          }
                      
                        />
                      </div>
                      <div className="py-4">
                        <TextField
                          id="longitude"
                          type="number"
                          value={locData.lng}
                          label="Longitude"
                          variant="outlined"
                          className={`w-100`}
                          name="longitude"
                          onChange={(e) =>
                            setLocData({ ...locData, lng: e.target.value })
                          }
                        />
                      </div>
                      <p className="py-4 f16-700"> Within the Radius of</p>
                      <div className="d-flex justify-between">
                        <div className="col-8">
                          <TextField
                            id="radius"
                            type="number"
                            label="Radius"
                            variant="outlined"
                            className={`w-100`}
                            name="radius"
                            onChange={(e) =>
                              setLocData({ ...locData, radius: e.target.value })
                            }
                            
                          />
                        </div>
                        <div className="col-4">
                          <MuiSelect
                            style={{ width: "100%" }}
                            value={locData.radiusType}
                            onChange={(e) =>
                              setLocData({
                                ...locData,
                                radiusType: e.target.value,
                              })
                            }
                            variant="outlined"
                            label="Mode"
                            inputProps={{
                              name: "Mode",
                              id: "outlined-state",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {modes.map((mode, index) => (
                              <option key={index} value={mode}>
                                {mode}
                              </option>
                            ))}
                          </MuiSelect>
                        </div>
                      </div>
                      <div className="py-4">
                        {(isEmpty(locData?.lat) || isEmpty(locData?.lng) || isEmpty(locData?.radius)) ? null : (
                          <AddButtonIconComponent
                            buttonText="Add Location"
                            onClick={() => onAddLocation(userData.data)}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        )}

                      </div>
                    </div>
                  </div>
                  <div className="my-4">
                    <div className="d-flex">
                      <h5
                        className="font_20_m c_red mr-3 cursor"
                        onClick={onOpenAddedlocations}
                      >
                        Show Added Locations
                      </h5>
                      <div className="cursor">
                        {displayDropDownlocations ? (
                          <i
                            className="fa fa-angle-up c_red"
                            aria-hidden="true"
                            onClick={onOpenAddedlocations}
                          ></i>
                        ) : (
                          <i
                            className="fa fa-angle-down c_red"
                            aria-hidden="true"
                            onClick={onOpenAddedlocations}
                          ></i>
                        )}
                      </div>
                    </div>
                    {displayDropDownlocations && addLocations.length ? (
                      addLocations.map((loc) => (
                        <>
                          <Row>
                            <Col xs={5}>
                              <span className="f14-600">
                                {loc.restaurant_name || ""}{" "}
                              </span>{" "}
                              <span className="f12-400">
                                {loc.lat} - {loc.lng}
                              </span>
                            </Col>
                            <Col xs={3}>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={() => onDeleteLocations(loc)}
                                fontIcon="fa fa-trash"
                                colorCss="delete"
                              />
                            </Col>
                          </Row>
                        </>
                      ))
                    ) : (
                      <></>
                    )}
                  </div>
                  <hr />
                  <Row className="mt-4 mb-4">
                    <Col md={7}>
                      <TextField
                        id="title"
                        label={
                          urlPath === "SMS"
                            ? "SMS Title*"
                            : urlPath === "EMAIL"
                              ? "Email Title*"
                              : urlPath === "NOTIFICATION"
                                ? "Notification Title*"
                                : null
                        }
                        type="text"
                        variant="outlined"
                        className={`w-100 ${formik1.errors.title && formik1.touched.title
                          ? "enError"
                          : ""
                          }`}
                        name="title"
                        onChange={formik1.handleChange}
                        value={formik1.values.title}
                        onBlur={formik1.handleBlur}
                        fullWidth
                      />
                      {formik1.errors.title && formik1.touched.title ? (
                        <div className="pho_14_regular text-danger">
                          {formik1.errors.title}
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                  <div className="mt-2 mb-3">
                    <div className="f14-700 mb-3">
                      {urlPath === "SMS"
                        ? "SMS"
                        : urlPath === "EMAIL"
                          ? "Email"
                          : urlPath === "NOTIFICATION"
                            ? "Notification"
                            : null}{" "}
                      Content*
                    </div>
                    {urlPath === "EMAIL" ? (
                      <React.Fragment>
                        <div>
                          <div>
                            {/* <button onClick={saveDesign}>Save Design</button> */}
                            <button
                              className="btn btn-danger"
                              onClick={exportHtml}
                            >
                              Export HTML
                            </button>
                          </div>

                          <React.StrictMode>
                            <EmailEditor ref={emailEditorRef} onLoad={onLoad} />
                          </React.StrictMode>
                        </div>
                      </React.Fragment>
                    ) : (
                      <TextField
                        // ref={description}
                        id="message"
                        label={
                          urlPath === "SMS"
                            ? "SMS Content"
                            : urlPath === "NOTIFICATION"
                              ? "Notification Content"
                              : null
                        }
                        type="text"
                        multiline
                        rows="5"
                        variant="outlined"
                        className={`w-100 ${formik1.errors.message && formik1.touched.message
                          ? "enError"
                          : ""
                          }`}
                        name="message"
                        onChange={formik1.handleChange}
                        value={formik1.values.message}
                        onBlur={formik1.handleBlur}
                        isInvalid={
                          formik1.errors.message && formik1.touched.message
                        }
                      />
                    )}
                    {formik1.errors.message && formik1.touched.message ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.message}
                      </div>
                    ) : null}
                  </div>
                  <div className="d-flex align-items-center pt-5 mb-3">
                    {/* <button
                      type="button"
                      className="mr-4 px-5 py-2 btn btn-outline-secondary"
                      onClick={(e) =>
                        urlPath === "SMS"
                          ? history.push("/superadminsmstemplatemanagement")
                          : urlPath === "EMAIL"
                          ? history.push("/superadminemailtemplatemanagement")
                          : urlPath === "NOTIFICATION"
                          ? history.push(
                              "/superadmin-notification-templatemanagement"
                            )
                          : ""
                      }
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      onClick={() => onClickSave()}
                      className="px-5 py-2 btn btn-danger"
                    >
                      Create
                    </button> */}
                    <SendNowModel
                      checkpreferences={checkpreferences}
                      addLocations={addLocations}
                      selectedUsers={selectedUsers}
                      data={formik1}
                      wholeData={wholeData}
                      onFormSubmit={() => onClickSave()}
                      reasonData={reasonData}
                      pathname={urlPath}
                    />
                    <SendLaterModel
                     checkpreferences={checkpreferences}
                     wholeData={wholeData}
                      data={formik1}
                      addLocations={addLocations}
                      selectedUsers={selectedUsers}
                      frequencyDataArr={frequencyData}
                      daysDataArr={daysData}
                      week_frequencyArr={week_frequency}
                      monthDataArr={monthData}
                      dayDataALLArr={dayDataALL}
                      onFormSubmit={() => onClickSave()}
                      pathname={urlPath}
                    />
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

SuperAdminAddSmsTemplate.propTypes = {
  auth: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
  admin_add_sms_email_template: propTypes.func.isRequired,
  admin_get_user_vendor_info: propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getVendorUserDetails: state.superAdminTemplates.get_user_vendor_info,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_add_sms_email_template,
  admin_get_user_vendor_info,
})(withRouter(SuperAdminAddSmsTemplate));

const SelectedAttributes = ({
  wholeData,
}) => {
  return (
    <>
    {wholeData?.sendToAll === 0 ? (
      <>
        <div className="f10-400 my-1">
            <span
              style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
            >
             Sent it to all Amealio users
            </span>
          </div>
      </>
     ) : ( 
      <> 
      {wholeData?.DobStarDate && wholeData?.DobSEndDate && (
        <>
          <div className="f10-400 my-1">
            <span
              style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
            >
              Date of birth :
            </span>
            <span>
              From : {wholeData?.DobStarDate} To : {wholeData?.DobSEndDate}
            </span>
          </div>
        </>
      )}
      {wholeData?.ActiveUsersStartdate && wholeData?.ActiveUsersenddate && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Active User's paramaters :
          </span>{" "}
          <span>
            {" "}
            From : {wholeData?.ActiveUsersStartdate} To :{" "}
            {wholeData?.ActiveUsersenddate}
          </span>
        </div>
      )}
      {wholeData?.AnniversaryStarDate && wholeData?.AnniversaryEndDate && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            User's Anniversary with Amealio :
          </span>{" "}
          <span>
            {" "}
            From : {wholeData?.AnniversaryStarDate} To :{" "}
            {wholeData?.AnniversaryEndDate}
          </span>
        </div>
      )}
      {wholeData?.country && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            country :
          </span>{" "}
          <span>{wholeData?.country}</span>
        </div>
      )}
      {wholeData?.state && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            state :
          </span>{" "}
          <span>{wholeData?.state}</span>
        </div>
      )}
      {wholeData?.city && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            city :
          </span>{" "}
          <span>{wholeData?.city}</span>
        </div>
      )}
      {wholeData?.gender?.length ? (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            gender :
            {wholeData?.gender?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      ) : null}
      {wholeData?.Allergies?.length ?  (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Allergies :
            {wholeData?.Allergies?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      )  : null}
      {wholeData?.Dietary?.length ? (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Dietary :
            {wholeData?.Dietary?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      ) : null}
      {wholeData?.Cuisines?.length ? (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Cuisines :
            {wholeData?.Cuisines?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      ) : null}
    </>
     )}
   </>
  )

}

const SendNowModel = (props) => {
  const [show, setShow] = useState(false);
  const onModalPopupOpen = () => {
    if ( (props?.addLocations?.length > 0 || props?.selectedUsers?.length > 0 || (!isEmpty(props?.wholeData) && props?.checkpreferences)) && props?.data?.values?.title !== " " && props.data.values.message !== "") {
      setShow(true);
      props.data.setFieldValue("isSendLater", false);
    } else {
      Alert.error(
        `<h4>Please fill the mandatory feilds, Then click send now button</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
    }
  };
  return (
    <>
      <button
        type="button"
        onClick={onModalPopupOpen}
        className="mr-4 px-3 py-2 f12-500 btn"
        style={{
          border: "1px solid #212121",
          borderRadius: "5px",
        }}
      >
        Send Now
      </button>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
      >
        <Modal.Header className="f20-500 border-0" closeButton>
          Enter the Reason
        </Modal.Header>
        <Modal.Body>
          <div className="f13-400 opacity5">
            Please provide your reason for the urgency of Sending SMS.
          </div>
          <div className="f14-500 mt-3">Reason</div>
          <FormControl variant="outlined" fullWidth>
            <Select
              // native
              value={props.data.values.reason}
              onChange={props.data.handleChange}
              inputProps={{
                label: "Reason",
                name: "reason",
                id: "outlined-SelectTemplate",
              }}
            >
              {props.reasonData.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="f14-500 mt-3 mb-2">Comments</div>
          <TextField
            id="comment"
            label="Comment"
            type="text"
            multiline
            rows="4"
            variant="outlined"
            className={`w-100 ${props.data.errors.comment && props.data.touched.comment
              ? "enError"
              : ""
              }`}
            name="comment"
            onChange={props.data.handleChange}
            value={props.data.values.comment}
            onBlur={props.data.handleBlur}
            isInvalid={props.data.errors.comment && props.data.touched.comment}
          />
          {props.data.errors.comment && props.data.touched.comment ? (
            <div className="pho_14_regular text-danger">
              {props.data.errors.comment}
            </div>
          ) : null}
          <div>
            <div className="mt-4 d-flex align-items-center">
              <button
                type="button"
                className="mr-4 px-3 py-2 f12-500 btn"
                style={{
                  border: "1px solid rgb(33, 33, 33)",
                  borderRadius: "5px",
                }}
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-3 py-2 btn f12-500 text-white"
                style={{ backgroundColor: "rgb(238, 58, 35)" }}
                onClick={props.onFormSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const SendLaterModel = (props) => {
  const [freq, setFreq] = useState(0);
  const [show, setShow] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    props.data.setFieldValue("startDate", e.target.value);
    props.data.setFieldValue("endDate", "");
    setMinEndDate(e.target.value);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD"); //
    setMinDate(data);
  }, []);

  const addWeekAndRemove = (dayData) => {
    let presentData = props.data.values.days;
    let newData = dayData.value;
    if (presentData.some((data) => data === newData)) {
      let presentObj = presentData.find((findData) => findData === newData);
      if (presentObj === 0 || presentObj) {
        presentData.splice(presentData.indexOf(presentObj), 1);
        props.data.setFieldValue("days", presentData);
      }
    } else {
      presentData.push(newData);
      props.data.setFieldValue("days", presentData);
    }
  };

  const onChangeSimpleChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    if (value > 31) {
      Alert.error(`<h4>Not entering this value</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      props.data.setFieldValue("onPerticularDay", number);
    }
  };

  const onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    if (props.data.values.perticularYearMonth === "") {
      Alert.error(`<h4>Please Select Month</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (
      props.data.values.perticularYearMonth === "04" ||
      props.data.values.perticularYearMonth === "06" ||
      props.data.values.perticularYearMonth === "09" ||
      props.data.values.perticularYearMonth === "11"
    ) {
      if (value > 30) {
        Alert.error(`<h4>Not entering this value</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        props.data.setFieldValue("onPerticularDay", number);
      }
    } else if (props.data.values.perticularYearMonth === "2") {
      if (value > 29) {
        Alert.error(`<h4>Not entering this value</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        props.data.setFieldValue("onPerticularDay", number);
      }
    } else if (
      props.data.values.perticularYearMonth === "01" ||
      props.data.values.perticularYearMonth === "03" ||
      props.data.values.perticularYearMonth === "05" ||
      props.data.values.perticularYearMonth === "07" ||
      props.data.values.perticularYearMonth === "08" ||
      props.data.values.perticularYearMonth === "10" ||
      props.data.values.perticularYearMonth === "12"
    ) {
      if (value > 31) {
        Alert.error(`<h4>Not entering this value</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        props.data.setFieldValue("onPerticularDay", number);
      }
    }
  };

  /************************************
   * @DESC On Click Radio Button Click
   ************************************/
  const onRadionButtonClick = () => {
    props.data.setFieldValue("isOnPerticularDay", true);
    props.data.setFieldValue("week_frequency", "");
    props.data.setFieldValue("days", "");
    props.data.setFieldValue("month", "");
  };

  const onDayRadionButtonClick = () => {
    props.data.setFieldValue("isOnPerticularDay", false);
    props.data.setFieldValue("perticularYearMonth", false);
    props.data.setFieldValue("onPerticularDay", false);
  };

  const onModalPopupOpen = () => {
    if ((props?.addLocations?.length > 0 || props?.selectedUsers?.length > 0 || (!isEmpty(props?.wholeData) && props?.checkpreferences)) &&  props?.data?.values?.title !== " " && props.data.values.message !== "") {
      setShow(true);
      props.data.setFieldValue("isSendLater", true);
    } else {
      Alert.error(
        `<h4>Please fill the mandatory feilds, Then click send Later button</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={onModalPopupOpen}
        className="px-3 py-2 btn f12-500 text-white"
        style={{ backgroundColor: "#EE3A23" }}
      >
        Send Later
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
      >
        <Modal.Header className="f20-500 border-0" closeButton>
          Frequency
        </Modal.Header>
        <Modal.Body>
          <div className="f13-400 mb-4" style={{ color: "#212121" }}>
            Select the frequency according to the preference
          </div>
          <FormControl variant="outlined" className="w-75" fullWidth>
            <InputLabel id="demo-simple-select-filled-label">
              Frequency
            </InputLabel>
            <Select
              value={props.data.values.frequency}
              onChange={props.data.handleChange}
              label="Frequency"
              inputProps={{
                name: "frequency",
                id: "outlined-every_week-native-simple",
              }}
            >
              {props.frequencyDataArr.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {(props.data.values.frequency === 0 ||
            props.data.values.frequency === 1 ||
            props.data.values.frequency === 2 ||
            props.data.values.frequency === 3 ||
            props.data.values.frequency === 4) && (
              <div className="mt-4">
                <div className="row align-items-center">
                  <div className="col-3">
                    <div className="f12-400">Start Date</div>
                  </div>
                  <div className="col-5">
                    <TextField
                      id="startDate"
                      label="Enter start date"
                      variant="outlined"
                      InputProps={{
                        inputProps: { min: minDate },
                      }}
                      type="date"
                      defaultValue={minDate}
                      className={`w-100 ${props.data.errors.startDate &&
                        props.data.touched.startDate
                        ? "enError"
                        : ""
                        }`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="startDate"
                      onChange={(e) => handleStartDateChange(e)}
                      //onChange={props.data.handleChange}
                      value={props.data.values.startDate}
                      onBlur={props.data.handleBlur}
                    />
                    {props.data.errors.startDate &&
                      props.data.touched.startDate ? (
                      <div className="pho_14_regular text-danger">
                        {props.data.errors.startDate}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="row mt-4 align-items-center">
                  <div className="col-3">
                    <div className="f12-400">End Date</div>
                  </div>
                  <div className="col-5">
                    <TextField
                      id="endDate"
                      label="Enter end date"
                      variant="outlined"
                      InputProps={{
                        inputProps: { min: minEndDate },
                      }}
                      type="date"
                      className={`w-100 ${props.data.errors.endDate && props.data.touched.endDate
                        ? "enError"
                        : ""
                        }`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="endDate"
                      onChange={props.data.handleChange}
                      value={props.data.values.endDate}
                      onBlur={props.data.handleBlur}
                    />
                    {props.data.errors.endDate && props.data.touched.endDate ? (
                      <div className="pho_14_regular text-danger">
                        {props.data.errors.endDate}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="f9-500 opacity5 mt-3">
                  Occurs every month on first week starting from 25/04/2021 till
                  25/06/2021
                </div>
                {props.data.values.frequency === 2 && (
                  <>
                    <div className="row mt-4 align-items-center">
                      <div className="col-3">
                        <div className="f12-400">Repeat Every</div>
                      </div>
                      <div className="col-4">
                        <div className="d-flex align-items-center">
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-filled-label">
                              Week
                            </InputLabel>
                            <Select
                              value={props.data.values.repeatEvery}
                              onChange={props.data.handleChange}
                              inputProps={{
                                name: "repeatEvery",
                                id: "outlined-every_week-native-simple",
                              }}
                              label="Week"
                            >
                              <MenuItem value={1}>1</MenuItem>
                              <MenuItem value={2}>2</MenuItem>
                              <MenuItem value={3}>3</MenuItem>
                              <MenuItem value={4}>4</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"></div>
                      <div className="col-9">
                        <div className="d-flex justify-content-between align-items-center">
                          {props.dayDataALLArr.map((data, index) => {
                            return (
                              <div
                                key={index}
                                align="center"
                                style={{
                                  borderRadius: "24px",
                                  width: "38px",
                                  height: "38px",
                                  padding: "6px",
                                  backgroundColor: props.data.values.days.some(
                                    (findValue) => findValue === data.value
                                  )
                                    ? "#EE3A23"
                                    : "#F5F5F5",
                                  color: props.data.values.days.some(
                                    (findValue) => findValue === data.value
                                  )
                                    ? "#FFFFFF"
                                    : "#212121",
                                }}
                                title={data.title}
                                name="days"
                                id="days"
                                onClick={() => addWeekAndRemove(data, index)}
                                className="cursor"
                              >
                                {data.name}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {props.data.values.frequency === 4 ||
                  props.data.values.frequency === 3 ? (
                  <>
                    <div className="row mt-3 align-items-center">
                      <div className="col-3">
                        <label className="enRadioWithText mr-3">
                          <span className="f14-400">On</span>
                          <input
                            type="radio"
                            name="isOnPerticularDay"
                            id="isOnPerticularDay"
                            value={props.data.values.isOnPerticularDay}
                            onChange={onRadionButtonClick}
                            checked={true === props.data.values.isOnPerticularDay}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div className="col-9">
                        <div className="d-flex align-items-center">
                          {props.data.values.frequency !== 3 ? (
                            <FormControl
                              variant="outlined"
                              fullWidth
                            // className="ml-3"
                            >
                              <InputLabel id="demo-simple-select-filled-label">
                                Month
                              </InputLabel>
                              <Select
                                value={props.data.values.perticularYearMonth}
                                onChange={props.data.handleChange}
                                label="Month"
                                inputProps={{
                                  name: "perticularYearMonth",
                                  id: "outlined-every_week-native-simple",
                                }}
                              >
                                {props.monthDataArr.map((item, index) => (
                                  <MenuItem key={index} value={item.data}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          ) : (
                            ""
                          )}
                          {props.data.values.frequency === 3 ? (
                            <FormControl
                              variant="outlined"
                              className={
                                props.data.values.frequency !== 3 ? "ml-2" : ""
                              }
                              // fullWidth
                              style={{ width: "48%" }}
                            >
                              <NewInputText
                                extraClass="mb-0"
                                name="onPerticularDay"
                                id="onPerticularDay"
                                inputType="number"
                                // onFocusOut={onFocusOut}
                                onChange={onChangeSimpleChange}
                                onKeyDown={InputNumberFunc}
                                value={props.data.values.onPerticularDay}
                                maxLength="2"
                                labelText="Perticular Day"
                              />
                              {props.data.errors.onPerticularDay &&
                                props.data.touched.onPerticularDay ? (
                                <div className="pho_14_regular text-danger">
                                  {props.data.errors.onPerticularDay}
                                </div>
                              ) : null}
                            </FormControl>
                          ) : (
                            <FormControl
                              variant="outlined"
                              className={
                                props.data.values.frequency !== 3 ? "ml-2" : ""
                              }
                              fullWidth
                            >
                              <NewInputText
                                extraClass="mb-0"
                                name="onPerticularDay"
                                id="onPerticularDay"
                                inputType="number"
                                // onFocusOut={onFocusOut}
                                onChange={onChange}
                                onKeyDown={InputNumberFunc}
                                value={props.data.values.onPerticularDay}
                                maxLength="2"
                                labelText="Perticular Day"
                              />
                              {props.data.errors.onPerticularDay &&
                                props.data.touched.onPerticularDay ? (
                                <div className="pho_14_regular text-danger">
                                  {props.data.errors.onPerticularDay}
                                </div>
                              ) : null}
                            </FormControl>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3 align-items-center">
                      <div className="col-3">
                        <label className="enRadioWithText f18-500">
                          <span className="f13-400">On Day</span>
                          <input
                            type="radio"
                            name="isOnPerticularDay"
                            id="isOnPerticularDay"
                            value={props.data.values.isOnPerticularDay}
                            onChange={onDayRadionButtonClick}
                            checked={
                              false === props.data.values.isOnPerticularDay
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div className="col-9">
                        <div className="d-flex align-items-center">
                          <FormControl variant="outlined" fullWidth>
                            {/* <InputLabel id="demo-simple-select-filled-label"></InputLabel> */}
                            <InputLabel id="demo-simple-select-filled-label">
                              Week
                            </InputLabel>
                            <Select
                              value={props.data.values.week_frequency}
                              onChange={props.data.handleChange}
                              label="Week"
                              inputProps={{
                                name: "week_frequency",
                                id: "outlined-every_week-native-simple",
                              }}
                            >
                              {props.week_frequencyArr.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className="ml-3"
                          >
                            <InputLabel id="demo-simple-select-filled-label">
                              Day
                            </InputLabel>
                            <Select
                              value={props.data.values.days}
                              onChange={props.data.handleChange}
                              label="Days"
                              inputProps={{
                                name: "days",
                                id: "outlined-every_week-native-simple",
                              }}
                            >
                              {props.daysDataArr.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                  {item.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {props.data.values.frequency !== 3 ? (
                            <>
                              <div className="ml-2 f12-500">Of</div>
                              <FormControl
                                variant="outlined"
                                fullWidth
                                className="ml-3"
                              >
                                <InputLabel id="demo-simple-select-filled-label">
                                  Month
                                </InputLabel>
                                <Select
                                  value={props.data.values.month}
                                  onChange={props.data.handleChange}
                                  label="Month"
                                  inputProps={{
                                    name: "month",
                                    id: "outlined-every_week-native-simple",
                                  }}
                                >
                                  {props.monthDataArr.map((item, index) => (
                                    <MenuItem key={index} value={item.value}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            )}
          <hr />
          <div className="f14-700 mt-3">SMS Triggered Time</div>
          <div className="f9-500 opacity5 mt-1 mb-3">
            Enter the time that will occur every day
          </div>
          <div className="row">
            <div className="col-4">
              <TextField
                id="startTriggeredAt"
                label="Start Time"
                variant="outlined"
                type="time"
                className={`w-100 ${props.data.errors.startTriggeredAt &&
                  props.data.touched.startTriggeredAt
                  ? "enError"
                  : ""
                  }`}
                InputLabelProps={{
                  shrink: true,
                }}
                name="startTriggeredAt"
                onChange={props.data.handleChange}
                value={props.data.values.startTriggeredAt}
                onBlur={props.data.handleBlur}
              />
              {props.data.errors.startTriggeredAt &&
                props.data.touched.startTriggeredAt ? (
                <div className="pho_14_regular text-danger">
                  {props.data.errors.startTriggeredAt}
                </div>
              ) : null}
            </div>
            {props.data.values.frequency === 0 ? (
              <div className="col-4">
                <TextField
                  id="endTriggeredAt"
                  label="End Time"
                  variant="outlined"
                  type="time"
                  className={`w-100 ${props.data.errors.endTriggeredAt &&
                    props.data.touched.endTriggeredAt
                    ? "enError"
                    : ""
                    }`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="endTriggeredAt"
                  onChange={props.data.handleChange}
                  value={props.data.values.endTriggeredAt}
                  onBlur={props.data.handleBlur}
                />
                {props.data.errors.endTriggeredAt &&
                  props.data.touched.endTriggeredAt ? (
                  <div className="pho_14_regular text-danger">
                    {props.data.errors.endTriggeredAt}
                  </div>
                ) : null}
              </div>
            ) : (
              ""
            )}
          </div>
          <div>
            <div className="mt-4 d-flex align-items-center">
              <button
                type="button"
                className="mr-4 px-3 py-2 f12-500 btn"
                style={{
                  border: "1px solid rgb(33, 33, 33)",
                  borderRadius: "5px",
                }}
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-3 py-2 btn f12-500 text-white"
                style={{ backgroundColor: "rgb(238, 58, 35)" }}
                onClick={props.onFormSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const reasonData = [
  {
    name: "Sales and Marketing Messages",
    value: "Sales and Marketing Messages",
  },
  {
    name: "SMS Notifications and Alerts",
    value: "SMS Notifications and Alerts",
  },
  {
    name: "Order Confirmation Messages",
    value: "Order Confirmation Messages",
  },
  {
    name: "Customer Service Messages",
    value: "Customer Service Messages",
  },
  { name: "Payment Reminders", value: "Payment Reminders" },
  {
    name: "Lead Engagement Messages",
    value: "Lead Engagement Messages",
  },
  {
    name: "Exclusive Offer Messages",
    value: "Exclusive Offer Messages",
  },
  {
    name: "Feedback and Review Messages",
    value: "Feedback and Review Messages",
  },
  { name: "Appointment Reminders", value: "Appointment Reminders" },
];

const frequencyData = [
  {
    name: "Hourly",
    value: 0,
  },
  {
    name: "Daily",
    value: 1,
  },
  {
    name: "Weekly",
    value: 2,
  },
  {
    name: "Monthly",
    value: 3,
  },
  { name: "Yearly", value: 4 },
];

const daysData = [
  {
    title: "Sunday",
    value: 0,
  },
  {
    title: "Monday",
    value: 1,
  },
  {
    title: "Tuesday",
    value: 2,
  },
  {
    title: "Wednesday",
    value: 3,
  },
  { title: "Thursday", value: 4 },
  { title: "Friday", value: 5 },
  { title: "Saturday", value: 6 },
  { title: "Whole_week", value: 7 },
];

const week_frequency = [
  {
    name: "First",
    value: 1,
  },
  { name: "Second", value: 2 },
  { name: "Third", value: 3 },
  { name: "Fourth", value: 4 },
  { name: "Last", value: 5 },
];

const monthData = [
  { name: "January", value: 0, data: "01" },
  { name: "February", value: 1, data: "02" },
  { name: "March", value: 2, data: "03" },
  { name: "April", value: 3, data: "04" },
  { name: "May", value: 4, data: "05" },
  { name: "June", value: 5, data: "06" },
  { name: "July", value: 6, data: "07" },
  { name: "August", value: 7, data: "08" },
  { name: "September", value: 8, data: "09" },
  { name: "October", value: 9, data: "10" },
  { name: "November", value: 10, data: "11" },
  { name: "December", value: 11, data: "12" },
];

const dayDataALL = [
  {
    name: "M",
    title: "Monday",
    value: 1,
  },
  {
    name: "T",
    title: "Tuesday",
    value: 2,
  },
  {
    name: "W",
    title: "Wednesday",
    value: 3,
  },
  { name: "T", title: "Thursday", value: 4 },
  { name: "F", title: "Friday", value: 5 },
  { name: "S", title: "Saturday", value: 6 },
  {
    name: "S",
    title: "Sunday",
    value: 0,
  },
];
